module.exports = __webpack_public_path__ + "static/media/ban-khar-software.6492932a.svg";